module.exports = __webpack_public_path__ + "static/media/HomeTab2.f6ed4663.jpg";